import { RootState } from 'store';
import jwtDecode from 'jwt-decode';
import { UserRoleEnum } from 'common/user/enums/user-role.enum';
import { localStorageWrapper } from 'functions/localStorage';

export interface IAccessToken {
  _id: string;
  firstName: string;
  lastName: string;
  organizationId: string;
  isReadOnly?: boolean;
  roles: UserRoleEnum[];
  exp: number;
  iat: number;
}

export const tokenSelector = (state: RootState) => state.user.accessToken;
export const rolesSelector = (state: RootState) => {
  const token = state.user.accessToken
    ? (jwtDecode(state.user.accessToken) as {
        roles: string[];
      })
    : undefined;
  return token?.roles || [];
};

export const jwtDecodedSelector = (
  state: RootState
): IAccessToken | undefined => {
  try {
    return state.user.accessToken
      ? jwtDecode(state.user.accessToken)
      : undefined;
  } catch (error) {
    localStorageWrapper.clear();
  }
};

export const userSelector = (state: RootState) => {
  return state.user;
};
